import PurchasedPlanBanner from "../components/Cart/PurchasedPlanBanner";
import PurchasedPlans from "../components/Cart/PurchasedPlans";
export default function PurchasedPlanPage() {
  return (
    <>
      <PurchasedPlanBanner />
      <PurchasedPlans />
    </>
  )
}
